import { initGeneral } from "../modules/general.js";
import { initAccordion } from "../modules/accordion.js";
import { initReviewsSmallSlider } from "../modules/slider-reviews-small.js";
import { initPlansSwitch } from "../modules/plans-switch.js";

jQuery(document).ready(function ($) {
	initGeneral();
	initAccordion();
	initReviewsSmallSlider();
	initPlansSwitch();
});
